/** Colors are #rrggbb, or #rrggbbaa when not fully opaque. */

export function splitAlpha(color: string): { rgb: string; alpha: number } {
  const m = /^#([0-9a-f]{6})([0-9a-f]{2})?$/i.exec(color.trim())
  if (!m) return { rgb: color, alpha: 1 }
  return {
    rgb: `#${m[1]!.toLowerCase()}`,
    alpha: m[2] ? parseInt(m[2], 16) / 255 : 1,
  }
}

export function withAlpha(rgb: string, alpha: number): string {
  const a = Math.round(Math.min(1, Math.max(0, alpha)) * 255)
  return a === 255 ? rgb : rgb + a.toString(16).padStart(2, '0')
}
